import React, { ReactNode, ReactText, useCallback } from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

export interface RadioProps {
  /** 表单项名称 */
  name?: string;
  /** 是否选中 */
  checked?: boolean;
  onChange?(checked: boolean, e: React.ChangeEvent<HTMLInputElement>): void;
  onClick?(val: ReactText | undefined): void;
  /** value 值 */
  value?: ReactText;
  label?: ReactNode;
  className?: string;
  checkedClassName?: string;
}

export default function (props: RadioProps) {
  const {
    name,
    label,
    value,
    checked,
    onChange,
    className,
    checkedClassName,
    onClick = () => {},
  } = props;
  const handleChange = useCallback(
    function (e: React.ChangeEvent<HTMLInputElement>) {
      return onChange ? onChange(e.target.checked, e) : undefined;
    },
    [onChange]
  );

  return (
    <label
      className={cn(styles.radio, className, {
        [checkedClassName || styles.checked]: checked,
      })}
      onClick={() => onClick(value)}
    >
      <input
        id={`${name}-${value}`}
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={handleChange}
      />
      {label}
    </label>
  );
}
